import { useOpenSubscriptionManagement as useOpenSubscriptionManagementShared } from '@griply/hooks';
import { useCallback } from 'react';
// eslint-disable-next-line max-len -- long hook name
import { useStripeSubscriptionManagementUrlQuery } from 'shared/hooks/queries/use-stripe-subscription-management-url-query';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { ActionEvents } from 'shared/services/tracking';
import { ID } from 'shared/types/id';

export const useOpenSubscriptionManagement = (
  stripeCustomerId: ID | undefined,
) => {
  const track = useTrackEvents();
  const { data, isFetching, refetch } =
    useStripeSubscriptionManagementUrlQuery(stripeCustomerId);

  const refetchUrl = useCallback(async () => {
    const result = await refetch();
    return result.data;
  }, [refetch]);

  const onTrigger = useCallback(
    () => track(ActionEvents.CancelSubscription, undefined),
    [track],
  );

  return useOpenSubscriptionManagementShared({
    data,
    isFetching,
    refetch: refetchUrl,
    onTrigger,
  });
};
